import { useMutation } from '@tanstack/react-query'
import { saveUtm } from '../../service/utm'

export const useSaveUtm = () => {
  return useMutation({
    mutationKey: ['save-utm'],
    mutationFn: saveUtm,
  })
}
